import { Host, h } from '@stencil/core';
export class AibaAnalysisResult {
  constructor() {
    this.handleChipModalClick = (event, renderData, name, value) => {
      this.chipModalVisible = true;
      this.chipModalData = renderData;
      this.handlers && this.handlers.handleChipModalClick(event, name, value);
    };
    this.handleDonutModalClick = (event, renderData, id, value) => {
      this.donotModalVisible = true;
      this.donotModalData = renderData;
      this.activateId = id;
      this.handlers && this.handlers.handleDonutModalClick(event, id, value);
    };
    this.handleViewAnalysisProgress = async (event) => {
      if (this.handlers && this.handlers.handleViewAnalysisProgress) {
        this.showProgressScreen = this.handlers.handleViewAnalysisProgress(event);
      }
    };
    this.handleToggleScoringBreakDown = async (event) => {
      this.showScoreBreakDownPopup = true;
      this.handlers && this.handlers.handleToggleScoringBreakDown && this.handlers.handleToggleScoringBreakDown();
      console.log(event);
    };
    this.navigateToLoginScreen = async (event) => {
      this.handlers && this.handlers.navigateToLoginScreen(event);
    };
    this.data = undefined;
    this.styles = undefined;
    this.handlers = undefined;
    this.chipModalVisible = false;
    this.chipModalData = undefined;
    this.donotModalVisible = false;
    this.donotModalData = undefined;
    this.userName = undefined;
    this.userImage = undefined;
    this.userLabelData = undefined;
    this.hairProfileLabel = undefined;
    this.hairDescription = undefined;
    this.donutData = undefined;
    this.donutDataForTags = undefined;
    this.renderDataForTags = undefined;
    this.showTagsModal = false;
    this.semiDonutData = undefined;
    this.showScoreBreakDownPopup = true;
    this.mainConcernDonutData = undefined;
    this.skinAge = undefined;
    this.skinScore = undefined;
    this.chipData = undefined;
    this.showProgressScreen = false;
    this.showAnalysisResultComponent = true;
    this.isLogin = false;
    this.showCarousel = true;
    this.activateId = '';
    this.contentData = undefined;
  }
  selfieAttributeInfoClicked(event) {
    if (event.detail['heading']) {
      this.renderDataForTags = event.detail;
      this.showTagsModal = true;
    }
    else if (event.detail['techName']) {
      let data, techName;
      data = event.detail['data'];
      techName = event.detail['techName'];
      console.log('event' + event);
      this.contentData = data;
      const contentElement = this.contentRef;
      this.activateId = techName;
      if (contentElement) {
        setTimeout(() => {
          window.scrollTo({
            top: contentElement.offsetTop,
            behavior: 'smooth',
          });
        }, 500);
      }
    }
  }
  closemodal() {
    this.chipModalVisible = false;
    this.donotModalVisible = false;
    this.showTagsModal = false;
  }
  closepopup() {
    this.showScoreBreakDownPopup = false;
  }
  closeProgressModel() {
    this.showProgressScreen = false;
  }
  async componentWillLoad(event) {
    if (this.handlers && this.handlers.handleComponentWillLoad) {
      const response = await this.handlers.handleComponentWillLoad(this.data, event);
      this.hairProfileLabel = response.profilelabel;
      this.hairDescription = response.hairDescription;
      this.donutData = response.donutData;
      this.donutDataForTags = response.donutDataForTags;
      this.mainConcernDonutData = response.mainConcernDonutData;
      this.chipData = response.chipData;
      this.skinAge = response.skinAge;
      this.skinScore = response.skinScore;
      this.isLogin = response === null || response === void 0 ? void 0 : response.isLogin;
      this.showCarousel = response === null || response === void 0 ? void 0 : response.showCarousel;
      if (response && Object.keys(response).includes('showAnalysisResultComponent')) {
        this.showAnalysisResultComponent = response.showAnalysisResultComponent;
      }
      if (response === null || response === void 0 ? void 0 : response.semiDonutData) {
        this.semiDonutData = response === null || response === void 0 ? void 0 : response.semiDonutData;
      }
    }
    if (this.handlers && this.handlers.santiseAnalyisResultData) {
      const { data } = await this.handlers.santiseAnalyisResultData(this.data);
      if (data)
        this.data = data;
    }
  }
  async componentDidLoad() {
    if (this.handlers && this.handlers.handleUpdateAnalysisResultImage) {
      this.userImage = await this.handlers.handleUpdateAnalysisResultImage();
    }
    if (this.handlers && this.handlers.handleUpdateUserNameOnAnalysisResult) {
      this.userName = await this.handlers.handleUpdateUserNameOnAnalysisResult(this.userLabelData);
    }
    if (this.handlers && this.handlers.handleAnalysisResultDidLoad) {
      await this.handlers.handleAnalysisResultDidLoad();
    }
  }
  render() {
    var _a;
    if (typeof this.data === 'string') {
      this.data = JSON.parse(this.data);
    }
    return (h(Host, null, this.styles && h("style", null, this.styles), this.showAnalysisResultComponent && (h("div", { class: "analysis-result-wrapper" }, this.data &&
      ((_a = this.data) === null || _a === void 0 ? void 0 : _a.elements.map((item) => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (item.name === 'left-skin-panel') {
          return (h("div", { class: "left-panel" }, (item === null || item === void 0 ? void 0 : item.data) &&
            ((_a = item === null || item === void 0 ? void 0 : item.data) === null || _a === void 0 ? void 0 : _a.elements.map(element => {
              var _a, _b, _c, _d, _e, _f, _g;
              if (element['name'] === 'aiba-label' && ((_c = (_b = (_a = element['data']) === null || _a === void 0 ? void 0 : _a.text) === null || _b === void 0 ? void 0 : _b.split('{{USERNAME}}')) === null || _c === void 0 ? void 0 : _c.length) > 1) {
                if (this.userLabelData !== element['data'].text) {
                  this.userLabelData = element['data'].text;
                }
                return h("aiba-label", Object.assign({}, element['data'], { text: this.userName ? this.userName : this.userLabelData }));
              }
              if (element['name'] === 'aiba-label' && element['_id'] && element['_id'] === 'profileLabel') {
                return h("aiba-label", Object.assign({}, element['data'], { text: this.hairProfileLabel ? this.hairProfileLabel : element['data']['text'] }));
              }
              if (element['name'] === 'aiba-label' && element['data'].text.split('{{USERNAME}}').length <= 1) {
                return h("aiba-label", Object.assign({}, element['data']));
              }
              if (element['name'] === 'aiba-prompt') {
                return h("aiba-prompt", { data: element['data'], id: element['_id'] });
              }
              if (!this.showCarousel && element['name'] === 'aiba-image' && element['data'] && element['data']['_id'] === 'userImagePlaceholder') {
                return (h("div", { class: "result_image_user-image" }, h("img", { src: this.userImage ? this.userImage : element.data.src, alt: element.data.altText })));
              }
              if (this.showCarousel && element['name'] === 'aiba-mask-carousel') {
                return (h("div", { class: "result_image_mask-carousel" }, h("aiba-mask-carousel", Object.assign({}, element, { handlers: this.handlers })), (_d = item === null || item === void 0 ? void 0 : item.data) === null || _d === void 0 ? void 0 :
                  _d.elements.map(element1 => {
                    var _a, _b, _c, _d, _e, _f;
                    if (element1['name'] === 'aiba-donut') {
                      return (h("aiba-donut", Object.assign({}, element1['data'], { value: ((_a = this.mainConcernDonutData) === null || _a === void 0 ? void 0 : _a.value) ? (_b = this.mainConcernDonutData) === null || _b === void 0 ? void 0 : _b.value : null, content: Object.assign({}, this.mainConcernDonutData), variant: (_c = this.mainConcernDonutData) === null || _c === void 0 ? void 0 : _c.status, borderWidth: ((_d = this.mainConcernDonutData) === null || _d === void 0 ? void 0 : _d.borderWidth) ? (_e = this.mainConcernDonutData) === null || _e === void 0 ? void 0 : _e.borderWidth : 10, data: element1['data'], renderForModal: false, size: (_f = this.mainConcernDonutData) === null || _f === void 0 ? void 0 : _f.size })));
                    }
                  })));
              }
              if (element['name'] === 'aiba-popup') {
                return (this.showScoreBreakDownPopup && (h("aiba-popup", { closeButtonData: element['data']['closeButtonData'], handlers: this.handlers }, (element === null || element === void 0 ? void 0 : element.data) &&
                  ((_e = element === null || element === void 0 ? void 0 : element.data) === null || _e === void 0 ? void 0 : _e.elements.map(innerElem => {
                    if (innerElem['name'] === 'aiba-label') {
                      return h("aiba-label", Object.assign({}, innerElem['data']));
                    }
                  })))));
              }
              if (element['name'] === 'aiba-button') {
                return (h("aiba-button", Object.assign({}, element['data'], { handleClick: (event) => this.handleToggleScoringBreakDown(event), classes: element && element['data'] && element['data']['classes'] ? element['data']['classes'] : '' })));
              }
              if (element['name'] === 'aiba-description-labels') {
                return (h("div", { class: "aiba-description-labels" }, ((_f = element === null || element === void 0 ? void 0 : element.data) === null || _f === void 0 ? void 0 : _f.elements) &&
                  ((_g = element === null || element === void 0 ? void 0 : element.data) === null || _g === void 0 ? void 0 : _g.elements.map(innerElem => {
                    if (innerElem['name'] === 'aiba-label') {
                      return h("aiba-label", Object.assign({}, innerElem['data']));
                    }
                  }))));
              }
            }))));
        }
        if (item.name === 'right-skin-panel') {
          return (h("div", { class: "right_panel" }, (item === null || item === void 0 ? void 0 : item.data) &&
            ((_b = item === null || item === void 0 ? void 0 : item.data) === null || _b === void 0 ? void 0 : _b.elements.map(element => {
              var _a, _b, _c, _d;
              if (element['name'] === 'aiba-label' && element['data'].text.split('{{USERNAME}}').length > 1) {
                if (this.userLabelData !== element['data'].text) {
                  this.userLabelData = element['data'].text;
                }
                return h("aiba-label", Object.assign({}, element['data'], { text: this.userName ? this.userName : this.userLabelData }));
              }
              if (element['name'] === 'aiba-label' && element['data'].text.split('{{USERNAME}}').length <= 1) {
                return h("aiba-label", Object.assign({}, element['data']));
              }
              if (!this.showCarousel && element['name'] === 'aiba-image' && element['data'] && element['data']['_id'] === 'userImagePlaceholder') {
                return (h("div", { class: "result_image_user-image" }, h("img", { src: this.userImage ? this.userImage : element.data.src, alt: element.data.altText })));
              }
              if (this.showCarousel && element['name'] === 'aiba-mask-carousel') {
                return (h("div", { class: "result_image_mask-carousel" }, h("aiba-mask-carousel", Object.assign({}, element, { handlers: this.handlers }))));
              }
              if (element['name'] === 'aiba-tag' && element['_id'] === 'skin-age') {
                return (h("div", { class: "tag-wrapper" }, h("aiba-tag", { data: element['data'], textDetails: this.skinAge ? this.skinAge : element['data']['text'], selfieAttributeDetails: this.donutDataForTags[element['_id']], handlers: this.handlers }), this.showTagsModal && (h("aiba-modal", { modalPosition: "center", handlers: this.handlers, closeButtonData: element['closeButtonData'] ? element['closeButtonData'] : '', handleClick: event => this.handlers && this.handlers.skinInfoModalClose && this.handlers.skinInfoModalClose(event) }, h("aiba-label", { tag: "h2", text: this.renderDataForTags['heading'] }), h("aiba-label", Object.assign({ tag: "p", text: this.renderDataForTags['description'], innerHTML: element['modal'] ? this.renderDataForTags['description'] : '' }, (element['modal'] ? Object.assign({}, (_a = element['modal']) === null || _a === void 0 ? void 0 : _a.data) : '')))))));
              }
              if (element['name'] === 'aiba-tag' && element['_id'] === 'skin-score-number') {
                return (h("div", { class: "tag-wrapper" }, h("aiba-tag", { data: element['data'], textDetails: this.skinScore ? this.skinScore : element['data']['text'], selfieAttributeDetails: this.donutDataForTags['skin-score'], handlers: this.handlers }), this.showTagsModal && (h("aiba-modal", { modalPosition: "center", handlers: this.handlers, closeButtonData: element['closeButtonData'] ? element['closeButtonData'] : '', handleClick: event => this.handlers && this.handlers.skinInfoModalClose && this.handlers.skinInfoModalClose(event) }, h("aiba-label", { tag: "h2", text: this.renderDataForTags['heading'] }), h("aiba-label", Object.assign({ tag: "p", text: this.renderDataForTags['description'], innerHTML: element['modal'] ? this.renderDataForTags['description'] : '' }, (element['modal'] ? Object.assign({}, (_b = element['modal']) === null || _b === void 0 ? void 0 : _b.data) : '')))))));
              }
              if (element['name'] === 'aiba-tag' && element['_id'] === 'skin-score') {
                return (h("div", { class: "tag-wrapper" }, h("aiba-tag", { data: element['data'], textDetails: this.semiDonutData ? this.semiDonutData : element['data']['text'], selfieAttributeDetails: this.donutDataForTags[element['_id']], handlers: this.handlers }), this.showTagsModal && (h("aiba-modal", { modalPosition: "center", handlers: this.handlers, closeButtonData: element['closeButtonData'] ? element['closeButtonData'] : '', handleClick: event => this.handlers && this.handlers.skinInfoModalClose && this.handlers.skinInfoModalClose(event) }, h("aiba-label", { tag: "h2", text: this.renderDataForTags['heading'] }), h("aiba-label", Object.assign({ tag: "p", text: this.renderDataForTags['description'], innerHTML: element['modal'] ? this.renderDataForTags['description'] : '' }, (element['modal'] ? Object.assign({}, (_c = element['modal']) === null || _c === void 0 ? void 0 : _c.data) : '')))))));
              }
              if (element['name'] === 'aiba-tag' && element['_id'] === 'score-details') {
                return (h("div", { class: "tag-wrapper" }, h("aiba-tag", { data: element['data'], textDetails: element['data']['text'], selfieAttributeDetails: element['_id'] === 'score-details' ? element['modalData'] : this.donutDataForTags[element['_id']], handlers: this.handlers }), this.showTagsModal && (h("aiba-modal", { modalPosition: "center", handlers: this.handlers, closeButtonData: element['closeButtonData'] ? element['closeButtonData'] : '', handleClick: event => this.handlers && this.handlers.skinInfoModalClose && this.handlers.skinInfoModalClose(event) }, h("aiba-label", { tag: "h2", text: this.renderDataForTags['heading'] }), h("aiba-label", Object.assign({ tag: "p", text: this.renderDataForTags['description'], innerHTML: element['modal'] ? this.renderDataForTags['description'] : '' }, (element['modal'] ? Object.assign({}, (_d = element['modal']) === null || _d === void 0 ? void 0 : _d.data) : '')))))));
              }
              if (element.name === 'aiba-semi-donut') {
                return (h("div", { class: "right-heading-container" }, this.semiDonutData ? (h("aiba-semi-donut", { data: (() => {
                    const data = element['data'];
                    if (Array.isArray(data)) {
                      return [...data];
                    }
                    else if (typeof data === 'object' && data !== null) {
                      return Object.assign({}, data);
                    }
                    else {
                      return data;
                    }
                  })(), value: this.semiDonutData, content: this.mainConcernDonutData })) : (h("aiba-semi-donut", { data: (() => {
                    const data = element['data'];
                    if (Array.isArray(data)) {
                      return [...data];
                    }
                    else if (typeof data === 'object' && data !== null) {
                      return Object.assign({}, data);
                    }
                    else {
                      return data;
                    }
                  })() }))));
              }
              if (element.name === 'aiba-tabs') {
                return h("aiba-tabs", { data: Object.assign({}, element) });
              }
              if (element && element['name'] === 'aiba-icon')
                return h("aiba-icon", Object.assign({}, element['data']));
              if (element.name === 'aiba-analysis-graph-view') {
                return h("aiba-analysis-graph-view", Object.assign({}, element, { handlers: this.handlers }));
              }
            }))));
        }
        if (item.name === 'bottom-skin-panel') {
          return (h("div", { class: "bottom-panel" }, (item === null || item === void 0 ? void 0 : item.data) &&
            ((_c = item === null || item === void 0 ? void 0 : item.data) === null || _c === void 0 ? void 0 : _c.elements.map((element) => {
              var _a, _b;
              if (element.name === 'aiba-analysis-concern-block') {
                return h("aiba-analysis-concern-block", { data: element.data, handlers: this.handlers });
              }
              if (element.name === 'aiba-result-content-block') {
                return (h("aiba-result-content-block", { data: element['data'], content: this.contentData ? this.contentData : ((_a = this.donutData) === null || _a === void 0 ? void 0 : _a.data[0].info) ? (_b = this.donutData) === null || _b === void 0 ? void 0 : _b.data[0].info : null, ref: el => (this.contentRef = el) }));
              }
              if (element.name === 'aiba-analysis-graph-view') {
                return h("aiba-analysis-graph-view", Object.assign({}, element, { handlers: this.handlers }));
              }
            }))));
        }
        if (item.name === 'left-panel') {
          return (h("div", { class: "left-panel" }, (item === null || item === void 0 ? void 0 : item.data) &&
            ((_d = item === null || item === void 0 ? void 0 : item.data) === null || _d === void 0 ? void 0 : _d.elements.map(element => {
              if (element['name'] === 'aiba-label' && element['data'].text.split('{{USERNAME}}').length > 1) {
                if (this.userLabelData !== element['data'].text) {
                  this.userLabelData = element['data'].text;
                }
                return h("aiba-label", Object.assign({}, element['data'], { text: this.userName ? this.userName : this.userLabelData }));
              }
              if (element['name'] === 'aiba-label' && element['_id'] && element['_id'] === 'profileLabel') {
                return h("aiba-label", Object.assign({}, element['data'], { text: this.hairProfileLabel ? this.hairProfileLabel : element['data']['text'] }));
              }
              if (element['name'] === 'aiba-label' && element['_id'] && element['_id'] === 'hairDescription') {
                return h("aiba-label", Object.assign({}, element['data'], { text: this.hairDescription ? this.hairDescription : element['data']['text'] }));
              }
              if (element['name'] === 'aiba-label' && element['data'].text.split('{{USERNAME}}').length <= 1) {
                return h("aiba-label", Object.assign({}, element['data']));
              }
              if (element['name'] === 'aiba-image') {
                return (h("div", { class: "result_image" }, h("img", { src: this.userImage ? this.userImage : element.data.src, alt: element.data.altText })));
              }
            }))));
        }
        if (item.name === 'right-panel') {
          return (h("div", { class: "right_panel" }, (item === null || item === void 0 ? void 0 : item.data) &&
            ((_e = item === null || item === void 0 ? void 0 : item.data) === null || _e === void 0 ? void 0 : _e.elements.map(element => {
              if (element.name === 'heading') {
                return (h("div", { class: "right-heading-container" }, element.data &&
                  element.data.elements.map(item => {
                    if (item.name === 'aiba-label')
                      return h("aiba-label", Object.assign({}, item['data']));
                  })));
              }
              if (element.name === 'description') {
                return (h("div", { class: "description-container" }, element.data &&
                  element.data.elements.map(item => {
                    var _a, _b, _c;
                    if (item.name === 'disclaimer') {
                      return (h("div", { class: "disclaimer" }, (item === null || item === void 0 ? void 0 : item.data) &&
                        ((_a = item === null || item === void 0 ? void 0 : item.data) === null || _a === void 0 ? void 0 : _a.elements.map(element => {
                          if (element.name === 'aiba-label')
                            return h("aiba-label", Object.assign({}, element['data']));
                        }))));
                    }
                    if (item.name === 'legends') {
                      return (h("div", { class: "legends-wrapper" }, (item === null || item === void 0 ? void 0 : item.data) &&
                        ((_b = item === null || item === void 0 ? void 0 : item.data) === null || _b === void 0 ? void 0 : _b.elements.map(element => {
                          if (element.name === 'aiba-legend')
                            return h("aiba-legend", Object.assign({}, element, { data: element['data'] }));
                        }))));
                    }
                    if (item.name === 'attributes') {
                      return (h("div", { class: "attributes-wrapper" }, (item === null || item === void 0 ? void 0 : item.data) &&
                        ((_c = item === null || item === void 0 ? void 0 : item.data) === null || _c === void 0 ? void 0 : _c.elements.map(element => {
                          var _a, _b, _c, _d, _e;
                          if (element.name === 'aiba-donut') {
                            const donut = this.donutData[element._id];
                            element['data'].elements[0].data.text = donut === null || donut === void 0 ? void 0 : donut.name;
                            element['data'].elements[1].data.text = donut === null || donut === void 0 ? void 0 : donut.value;
                            return (h("div", { class: "donut-wrapper" }, h("aiba-donut", { handleClick: (event) => this.handleDonutModalClick(event, { [element._id]: element === null || element === void 0 ? void 0 : element.data }, element._id, donut === null || donut === void 0 ? void 0 : donut.value), value: (donut === null || donut === void 0 ? void 0 : donut.score) ? donut === null || donut === void 0 ? void 0 : donut.score : element === null || element === void 0 ? void 0 : element.data.value, variant: (donut === null || donut === void 0 ? void 0 : donut.variant) ? donut === null || donut === void 0 ? void 0 : donut.variant : element === null || element === void 0 ? void 0 : element.data.variant, data: element['data'], renderForModal: false, class: this.activateId === (element === null || element === void 0 ? void 0 : element._id) ? 'active' : '' }), this.donotModalVisible && Object.keys(this.donotModalData)[0] === element._id && (h("aiba-modal", { modalPosition: "center", handlers: this.handlers, handleClick: event => this.handlers && this.handlers.donutModalClose && this.handlers.donutModalClose(event) }, h("aiba-label", { tag: "h2", text: (_a = this.donotModalData[element._id]) === null || _a === void 0 ? void 0 : _a.elements[0].data.text }), h("aiba-donut", { value: (donut === null || donut === void 0 ? void 0 : donut.score) ? donut.score : (_b = this.donotModalData[element._id]) === null || _b === void 0 ? void 0 : _b.value, variant: (donut === null || donut === void 0 ? void 0 : donut.variant) ? donut.variant : (_c = this.donotModalData[element._id]) === null || _c === void 0 ? void 0 : _c.variant, data: this.donotModalData[element._id], renderForModal: true, size: 196, borderWidth: 16 }), h("aiba-label", { tag: "p", text: (_e = (_d = this.donotModalData[element._id]) === null || _d === void 0 ? void 0 : _d.elements[2].data) === null || _e === void 0 ? void 0 : _e.modalLabels[donut.key] })))));
                          }
                        }))));
                    }
                  })));
              }
              if (element.name === 'aiba-chips-container') {
                return (h("div", { class: "aiba-chips-container" }, element.data &&
                  element.data.elements.map((item) => {
                    const chip = this.chipData[item._id];
                    item['data'].elements[0].data.text = chip === null || chip === void 0 ? void 0 : chip.name;
                    item['data'].elements[1].data.text = chip === null || chip === void 0 ? void 0 : chip.value;
                    if (item.name === 'aiba-chip') {
                      return (h("div", { class: "chip-wrapper" }, h("aiba-chip", { data: Object.assign({}, item['data']), handleClick: (event) => this.handleChipModalClick(event, { [item._id]: item['data'] }, chip === null || chip === void 0 ? void 0 : chip.name, chip === null || chip === void 0 ? void 0 : chip.value) }), this.chipModalVisible && Object.keys(this.chipModalData)[0] === item._id && (h("aiba-modal", { modalPosition: "center", handlers: this.handlers, handleClick: event => this.handlers && this.handlers.chipModalClose && this.handlers.chipModalClose(event) }, h("aiba-label", { tag: "h2", text: this.chipModalData[item._id].elements[0].data.text }), h("aiba-label", { tag: "p", text: this.chipModalData[item._id].elements[2].data.modalLabels[chip.key] })))));
                    }
                  })));
              }
              if (element.name === 'aiba-label') {
                return h("aiba-label", Object.assign({}, element['data']));
              }
            }))));
        }
        if (item.name === 'left-skin-coach-panel') {
          return (h("div", { class: "left-skin-coach-panel-wrapper" }, (item === null || item === void 0 ? void 0 : item.data) &&
            ((_f = item === null || item === void 0 ? void 0 : item.data) === null || _f === void 0 ? void 0 : _f.elements.map(element => {
              if (element['name'] === 'aiba-label' && element['data'].text.split('{{USERNAME}}').length > 1) {
                if (this.userLabelData !== element['data'].text) {
                  this.userLabelData = element['data'].text;
                }
                return h("aiba-label", Object.assign({}, element['data'], { text: this.userName ? this.userName : this.userLabelData }));
              }
              if (element['name'] === 'aiba-label' && element['_id'] && element['_id'] === 'profileLabel') {
                return h("aiba-label", Object.assign({}, element['data'], { text: this.hairProfileLabel ? this.hairProfileLabel : element['data']['text'] }));
              }
              if (element['name'] === 'aiba-label' && element['data'].text.split('{{USERNAME}}').length <= 1) {
                return (h("main", { class: "username-wrapper" }, h("aiba-label", Object.assign({}, element['data']))));
              }
              if (element['name'] === 'aiba-prompt') {
                return h("aiba-prompt", { data: element['data'] });
              }
              if (element['name'] === 'aiba-image' && element['data'] && element['data']['_id'] && element['data']['_id'] !== 'userImagePlaceholder') {
                return (h("div", { class: "userImageWrapper" }, h("img", { src: element.data.src, alt: element.data.altText })));
              }
              if (!this.showCarousel && element['name'] === 'aiba-image' && element['data'] && element['data']['_id'] === 'userImagePlaceholder') {
                return (h("div", { class: "result_image_user-image" }, h("img", { src: this.userImage ? this.userImage : element.data.src, alt: element.data.altText })));
              }
              if (this.showCarousel && element['name'] === 'aiba-mask-carousel') {
                return (h("div", { class: "result_image_mask-carousel" }, h("aiba-mask-carousel", Object.assign({}, element, { handlers: this.handlers }))));
              }
              if (element &&
                element['name'] === 'aiba-button' &&
                element['data'] &&
                element['data']['_id'] &&
                element['data']['_id'] === 'progressScreenButton' &&
                this.isLogin === true)
                return (h("aiba-button", Object.assign({}, element['data'], { handleClick: (event) => this.handleViewAnalysisProgress(event), classes: element && element['data'] && element['data']['classes'] ? element['data']['classes'] : '' })));
              if (element &&
                element['name'] === 'aiba-button' &&
                element['data'] &&
                element['data']['_id'] &&
                element['data']['_id'] === 'loginButton' &&
                this.isLogin === false)
                return (h("aiba-button", Object.assign({}, element['data'], { handleClick: (event) => this.navigateToLoginScreen(event), classes: element && element['data'] && element['data']['classes'] ? element['data']['classes'] : '' })));
            }))));
        }
        if (item.name === 'right-skin-coach-panel') {
          return (h("div", { class: "right-skin-coach-panel-wrapper" }, (item === null || item === void 0 ? void 0 : item.data) &&
            ((_g = item === null || item === void 0 ? void 0 : item.data) === null || _g === void 0 ? void 0 : _g.elements.map(element => {
              if (element.name === 'aiba-semi-donut') {
                return (h("div", { class: "right-heading-container" }, this.semiDonutData ? (h("aiba-semi-donut", { data: Object.assign({}, element['data']), value: this.semiDonutData })) : (h("aiba-semi-donut", { data: Object.assign({}, element['data']) }))));
              }
              if (element.name === 'aiba-tabs') {
                return (h("div", { class: "tab-container" }, h("aiba-tabs", { data: Object.assign({}, element), handlers: this.handlers })));
              }
              if (element.name === 'aiba-analysis-graph-view') {
                return h("aiba-analysis-graph-view", { data: Object.assign({}, element), handlers: this.handlers });
              }
            }))));
        }
        if (item.name === 'bottom-skin-coach-panel') {
          return (h("div", { class: "bottom-skin-coach-panel-wrapper" }, (item === null || item === void 0 ? void 0 : item.data) &&
            ((_h = item === null || item === void 0 ? void 0 : item.data) === null || _h === void 0 ? void 0 : _h.elements.map((element) => {
              if (element.name === 'aiba-analysis-concern-block') {
                return h("aiba-analysis-concern-block", { data: element.data, handlers: this.handlers });
              }
            })), h("aiba-analysis-concern-block", { data: item.data })));
        }
        if (item.name === 'aiba-progress-screen') {
          return (this.showProgressScreen && (h("div", { class: "progress-screen-wrapper" }, h("aiba-progress-screen", { data: item.data, handlers: this.handlers, handleOnCloseClick: displayProgressScreen => (this.showProgressScreen = displayProgressScreen) }))));
        }
      }))))));
  }
  static get is() { return "aiba-analysis-result"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-analysis-result.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-analysis-result.css"]
    };
  }
  static get properties() {
    return {
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data",
        "reflect": false
      },
      "styles": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "chipModalVisible": {},
      "chipModalData": {},
      "donotModalVisible": {},
      "donotModalData": {},
      "userName": {},
      "userImage": {},
      "userLabelData": {},
      "hairProfileLabel": {},
      "hairDescription": {},
      "donutData": {},
      "donutDataForTags": {},
      "renderDataForTags": {},
      "showTagsModal": {},
      "semiDonutData": {},
      "showScoreBreakDownPopup": {},
      "mainConcernDonutData": {},
      "skinAge": {},
      "skinScore": {},
      "chipData": {},
      "showProgressScreen": {},
      "showAnalysisResultComponent": {},
      "isLogin": {},
      "showCarousel": {},
      "activateId": {},
      "contentData": {}
    };
  }
  static get listeners() {
    return [{
        "name": "infoSelfieAttributeClicked",
        "method": "selfieAttributeInfoClicked",
        "target": "window",
        "capture": false,
        "passive": false
      }, {
        "name": "closemodal",
        "method": "closemodal",
        "target": "window",
        "capture": false,
        "passive": false
      }, {
        "name": "closepopup",
        "method": "closepopup",
        "target": "window",
        "capture": false,
        "passive": false
      }, {
        "name": "closeProgressModel",
        "method": "closeProgressModel",
        "target": undefined,
        "capture": false,
        "passive": false
      }];
  }
}
//# sourceMappingURL=aiba-analysis-result.js.map
